import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  freeTrialWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  root: {
    width: '100%',
    padding: theme.spacing(1, 3, 1, 3),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  customWrapper: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(1),
  },
  createdAtWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  createdAtDate: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    lineHeight: theme.spacing(3),
  },
  createdAtTime: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
  },
  confirmDeActivateDesc: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
    fontWeight: 400,
    marginTop: theme.spacing(-2.25),
  },
  eulaSection: {
    paddingTop: theme.spacing(0),
  },
  numberOfDaysSection: {
    paddingBottom: theme.spacing(0),
  },
  dimensionKeyValue: {
    lineHeight: theme.spacing(3),
  },
}))
